import * as XLSX from "xlsx";

export const exportFile = (srcData, sheetName, sheetFileName) => {
    const ws = XLSX.utils.aoa_to_sheet(srcData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${sheetFileName}.xlsx`);
}

const colRender = (c, d) => Object.prototype.hasOwnProperty.call(c, 'render') && c.render(d) || d

export const exportReportFile = (srcData, srcCol, sheetName, sheetFileName, reportInfo = []) => {

    const titleCOLXLSX = srcCol.map(c => c.title)
    const dataCOLXSX = srcData.map(d => {
        return srcCol.map(c => {
            if (Object.prototype.hasOwnProperty.call(c, 'dataIndex')) {
                return colRender(c, d[c.dataIndex])
            } else {
                return colRender(c, d)
            }
        })
    })

    const maxLabelLen = Math.max(...reportInfo.map(info => info.label.length), 0)
    const headerRows = reportInfo.map(info => {
        const paddedLabel = info.label.padEnd(maxLabelLen, ' ')
        return [`${paddedLabel} : ${info.value}`]
    })
    headerRows.push([])

    const srcXLSX = [
        ...headerRows,
        titleCOLXLSX,
        ...dataCOLXSX
    ]

    const ws = XLSX.utils.aoa_to_sheet(srcXLSX)

    const colSpan = srcCol.length
    const infoRowCount = reportInfo.length

    ws['!merges'] = ws['!merges'] || []
    for (let r = 0; r < infoRowCount; r++) {
        ws['!merges'].push({ s: { r, c: 0 }, e: { r, c: colSpan - 1 } })
    }

    // === Auto width per kolom, berdasarkan konten terpanjang ===
    ws['!cols'] = srcCol.map((c, colIdx) => {
        const headerLen = c.title.length
        const maxDataLen = dataCOLXSX.reduce((max, row) => {
            const val = row[colIdx] != null ? String(row[colIdx]) : ''
            return Math.max(max, val.length)
        }, 0)
        const width = Math.max(headerLen, maxDataLen) + 2 // padding
        return { wch: Math.min(width, 50) } // cap biar ga kepanjangan
    })

    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, sheetName)
    XLSX.writeFile(wb, `${sheetFileName}.xlsx`)
}

export const convertXLSXArr2JSON = (aoa, headerRowIndex) => {
    const header = aoa[headerRowIndex]
    const caoa = aoa.filter((d, index) => index != headerRowIndex)
    return (
        caoa
        &&
        caoa.length
        &&
        caoa.map(ca =>  Object.fromEntries(ca.map((a, i) => [header[i], a]).filter(a => a)))
        ||
        []
    )
}

export const readXLSXFile = (file) => {
    const wk = XLSX.read(file, { type: "binary" });
    const sn = wk.SheetNames[0];
    const ws = wk.Sheets[sn];
    const rd = XLSX.utils.sheet_to_json(ws, { header: 1 }).filter(td => td && td.length);

    return convertXLSXArr2JSON(rd, 0)
}